module.exports = __webpack_public_path__ + "static/webinar-1b71c873f2b38588dd1d0c41f02ee543.jpeg";